import React from "react";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import messages from 'res/messages/farsi'

import ICArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';

export default function TitleImageHeader(props) {

    let header = props.header

    let titleColor = 'var(--gray_4)'
    if (header.titleColor) {
        titleColor = header.titleColor
    }

    function getClassName() {
        if (header.font_size_title === "1") {
            return "smallTextBold";
        } else if (header.font_size_title === "2") {
            return "mediumTextBold";
        } else if (header.font_size_title === "3") {
            return "largeTextBold";
        } else if (header.font_size_title === "4") {
            return "xLargeTextBold";
        } else if (header.font_size_title === "5") {
            return "xxLargeTextBold";
        } else if (header.font_size_title === "6") {
            return "xxxLargeTextBold";
        }
        return "largeTextBold";
    }

    return (

        <div style={{minWidth:'10rem'}}>
            { props.dataType && props.dataType==="homeProductList" ?   <div className="flex-column flexContentSpaceAround  fullWidth  marginCenter" style={{height:'300px',margin:'0 0.3rem'}}>
                <div className={"fullWidth"}>
                    {header.title &&
                        <div>
                            <p style={{color: titleColor}} className={getClassName()}>
                                {header.title}
                            </p>
                        </div>
                    }
                    {header.description &&
                        <div>
                            <p className="smallText">
                                {header.description}
                            </p>
                        </div>
                    }

                </div>
                {header.image &&
                    <div >
                        <img style={{maxWidth:'400px',maxHeight:'200px'}}
                             src={header.image} alt=""/>
                    </div>
                }
                <div>
                    {header.on_more &&
                        <IconTitleButtonRound
                            width="70%"
                            height="2.5em"
                            onClick={() => {
                                props.onAllClicked()
                            }}
                            icon={<ICArrowBackIosIcon className="whiteColor" fontSize="small"/>}
                            title={messages.seeAll}/>
                    }
                </div>
            </div> :  <table className="fullWidth fullHeight">
                <tbody>
                <tr>
                    <td style={{color: titleColor}}>
                        {header.title &&
                            <div className={getClassName()}>
                                {header.title}
                            </div>
                        }
                        {header.description &&
                            <div className="smallText">
                                {header.description}
                            </div>
                        }
                    </td>
                </tr>
                <tr style={{height: "5%"}}>
                    <td>
                        {header.image &&
                            <img className="fullWidth"
                                 src={header.image} alt=""/>
                        }
                    </td>
                </tr>
                <tr>
                    <td>
                        {header.on_more &&
                            <IconTitleButtonRound
                                width="70%"
                                height="2.5em"
                                onClick={() => {
                                    props.onAllClicked()
                                }}
                                icon={<ICArrowBackIosIcon className="whiteColor" fontSize="small"/>}
                                title={messages.seeAll}/>
                        }
                    </td>
                </tr>
                </tbody>
            </table> }


        </div>
    )
}